import { ref } from 'vue'
// by convention, composable function names start with 'use'
export function useDualOverlayHelpers() {
	// state encapsulated and managed by the composable

	const is_desktop_overlay_active = ref(false)
	const is_mobile_overlay_active = ref(false)

	function flipDualOverlay(overlay = 'desktop') {
		if (overlay === 'desktop') {
			is_desktop_overlay_active.value = !is_desktop_overlay_active.value
		} else {
			is_mobile_overlay_active.value = !is_mobile_overlay_active.value
		}
	}
	// expose managed state as return value
	return { is_desktop_overlay_active, is_mobile_overlay_active, flipDualOverlay }
}
